import { useState, forwardRef } from 'react';
import useForkRef from '@mui/utils/useForkRef';
import { styled } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { unstable_useDateField as useDateField } from '@mui/x-date-pickers/DateField';
import { useClearableField } from '@mui/x-date-pickers/hooks';
import { Unstable_PickersSectionList as PickersSectionList } from '@mui/x-date-pickers/PickersSectionList';
import dayjs from 'dayjs';

const BrowserFieldRoot = styled('div', { name: 'BrowserField', slot: 'Root' })({
    display: 'flex',
    alignItems: 'center',
    border: '0px solid #F1F1F1',
    backgroundColor: '#F1F1F1',
    justifyContent: 'space-between',
    padding: '10px',
    borderRadius: '8px',
});


const BrowserFieldContent = styled('div', { name: 'BrowserField', slot: 'Content' })(
    {},
);

const BrowserTextField = forwardRef((props, ref) => {

  const {
    // Should be ignored
    enableAccessibleFieldDOMStructure,
    // Should be passed to the PickersSectionList component
    elements,
    sectionListRef,
    contentEditable,
    onFocus,
    onBlur,
    tabIndex,
    onInput,
    onPaste,
    onKeyDown,
    // Can be passed to a hidden <input /> element
    onChange,
    value,
    // Can be used to render a custom label
    label,
    // Can be used to style the component
    areAllSectionsEmpty,
    disabled,
    readOnly,
    focused,
    error,
    InputProps: { ref: InputPropsRef, startAdornment, endAdornment } = {},
    // The rest can be passed to the root element
    ...other
  } = props;

  const handleRef = useForkRef(InputPropsRef, ref);

  return (
    <BrowserFieldRoot ref={handleRef} {...other}>
      {startAdornment}
      <BrowserFieldContent>
        <PickersSectionList
          elements={elements}
          sectionListRef={sectionListRef}
          contentEditable={contentEditable}
          onFocus={onFocus}
          onBlur={onBlur}
          tabIndex={tabIndex}
          onInput={onInput}
          onPaste={onPaste}
          onKeyDown={onKeyDown}
        />
      </BrowserFieldContent>
      {endAdornment}
    </BrowserFieldRoot>
  );
});

const BrowserDateField = forwardRef((props, ref) => {
  const { slots, slotProps, ...textFieldProps } = props;

  const fieldResponse = useDateField({
    ...textFieldProps,
    enableAccessibleFieldDOMStructure: true,
  });

  /* If you don't need a clear button, you can skip the use of this hook */
  const processedFieldProps = useClearableField({
    ...fieldResponse,
    slots,
    slotProps,
  });

  return <BrowserTextField ref={ref} {...processedFieldProps} />;
});

const BrowserDatePicker = forwardRef((props, ref) => {
    return (
        <DatePicker
            ref={ref}
            {...props}
            slots={{ field: BrowserDateField, ...props.slots}}
            format="DD-MM-YYYY"
        />
    );
});


export default function DateInputField({setDataFromChild, startDate, dateInput, disableDate, week, name}) {
    const [date, setDate] = useState(dateInput ? dateInput : null);
    const handleDate = (value) => {
        if(value.$M > 8) {
            if(value.$D > 9) {
                var date = value.$y+'-'+(value.$M+1)+'-'+value.$D;
            } else {
                var date = value.$y+'-'+(value.$M+1)+'-'+'0'+value.$D;
            }
        } else {
            if(value.$D > 9) {
                var date = value.$y+'-0'+(value.$M+1)+'-'+value.$D;
            } else {
                var date = value.$y+'-0'+(value.$M+1)+'-'+'0'+value.$D;
            }
        }
        setDate(value);
        if(name) {
          setDataFromChild({"id" : name, "date" : date});
        } else {
          setDataFromChild(date);
        }
        
    }

    const isWeekend = (date) => {
      const day = date.day();
      const array = week;
      return day === array[0] || day === array[1] || day === array[2] || day === array[3] || day === array[4] || day === array[5] || day === array[6]   
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <BrowserDatePicker
                slotProps={{
                    field: { clearable: false },
                }}
                name={name ? name : "date"}
                value={dayjs(date)}
                onChange={(newValue) => handleDate(newValue)}
                minDate={startDate}
                shouldDisableDate={disableDate ? isWeekend : false}
            />
        </LocalizationProvider>
    );
}